<template>
  <div>
    <div
      v-for="(alert,index) in alerts"
      :key="index"
      style="height: 100%;"
    >
      <b-alert
        class="p-2"
        style="height: 100%;position: relative;"
        show
        :variant="alert.color.toLowerCase()"
      >
        <h4> {{ alert.title }}</h4>
        <p v-html="alert.text" />
      </b-alert>
    </div>
    <p v-if="loading">
      <b-spinner label="Loading..." />
    </p>
    <div v-if="description && !loading">
      <p v-html="description" />
    </div>
  </div>
</template>

<script>
import DescriptionApis from '@/services/apis/description'

const description = new DescriptionApis()
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      description: null,
      loading: false,
      alerts: [],
    }
  },
  watch: {
    '$store.state.appConfig.layout.isRTL': {
      handler() {
        this.alerts = []
        this.description = null
        this.getDescriptions()
      },
    },
  },
  async created() {
    await this.getDescriptions()
  },
  methods: {
    async getDescriptions() {
      this.loading = true

      try {
        const { name } = this.$props
        const res = await description.get({ name })

        try {
          const parsedValue = JSON.parse(res.data.results.value)
          this.description = parsedValue.value
          this.alerts = parsedValue.alertTexts
        } catch {
          this.description = res.data.results.value
          this.alerts = []
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Add your styles here */
</style>
